import React from 'react';

export type ContentWidthMode = 'contained' | 'full';

const clamp = (value: number, min: number, max: number) => Math.max(min, Math.min(max, value));

export const resolveContentWidthMode = (value?: string): ContentWidthMode =>
  value === 'full' ? 'full' : 'contained';

export const resolveContentMaxWidth = (value: unknown, fallback: number) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return fallback;
  return clamp(parsed, 480, 2000);
};

export const getContentContainerProps = (
  config: any,
  fallbackWidth: number,
  extraClassName = ''
): { className: string; style: React.CSSProperties | undefined } => {
  const mode = resolveContentWidthMode(config?.contentWidth);
  const maxWidth = resolveContentMaxWidth(config?.contentMaxWidth, fallbackWidth);
  const className = `${mode === 'full' ? 'w-full' : 'w-full mx-auto'} ${extraClassName}`.trim();
  const style = mode === 'contained' ? { maxWidth: `${maxWidth}px` } : undefined;
  return { className, style };
};

